import React, { useState, useEffect } from 'react';

const NAV = [
  { label: 'How It Works', href: '#console' },
  { label: 'Showcase', href: '#showcase' },
  { label: 'Use Cases', href: '#use-cases' },
  { label: 'Privacy', href: '#privacy' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const smoothTo = (href) => {
    setOpen(false);
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 w-full transition-all duration-300 ${
        scrolled ? 'backdrop-blur-xl bg-[#05080C]/60 border-b border-white/5' : 'backdrop-blur-md bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-2" data-testid="header-logo">
          <img src="/simnopsis-logo.png" alt="SIMNOPSIS" className="h-8 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-1" data-testid="header-nav">
          {NAV.map(n => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => { e.preventDefault(); smoothTo(n.href); }}
              className="px-3 py-2 text-sm text-white/70 hover:text-white transition-colors"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            className="btn-ghost text-sm"
            onClick={() => smoothTo('#use-cases')}
            data-testid="cta-try-sample"
          >
            Try a sample
          </button>
          <button
            className="btn-gradient text-sm"
            onClick={() => smoothTo('#upload')}
            data-testid="cta-upload-audio"
          >
            Upload Audio
          </button>
        </div>

        <button
          className={`md:hidden hamb ${open ? 'open' : ''} p-2 -mr-2`}
          onClick={() => setOpen(v => !v)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          <span className="hamb-line" />
          <span className="hamb-line" />
          <span className="hamb-line" />
        </button>
      </div>

      {/* Mobile dropdown */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out backdrop-blur-xl bg-[#05080C]/80 border-b border-white/5 ${
          open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-2">
          {NAV.map((n, i) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => { e.preventDefault(); smoothTo(n.href); }}
              className="py-2 text-white/80 hover:text-white"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              {n.label}
            </a>
          ))}
          <div className="flex gap-3 pt-3">
            <button className="btn-ghost text-sm flex-1" onClick={() => smoothTo('#use-cases')}>Try a sample</button>
            <button className="btn-gradient text-sm flex-1" onClick={() => smoothTo('#upload')}>Upload Audio</button>
          </div>
        </div>
      </div>
    </header>
  );
}
